/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IGameData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IPixiesVsPiratesGameData, IPixiesVsPiratesServerData} from "./serverdata/IPixiesVsPiratesServerData";

export class PixiesVsPiratesServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseReels(rawData:IPixiesVsPiratesServerData):string[][] {
        const isFreeSpin:boolean = rawData.mode === GameMode.FREESPIN;
        rawData.gameAreaSize.forEach((reelSize:number, reelId:number) => {
            (<number[]>GameConfig.instance.STACKED_SYMBOLS!["W"].totalNum)[reelId] = isFreeSpin ? 6 : rawData.isRestoreState? reelSize : 3;
        });

        return super.parseReels(rawData);
    }

    public parseGameAreaSize(rawData:IPixiesVsPiratesServerData):number[] {
        return rawData.gameAreaSize.concat();
    }

    public parseDoReelNudge(rawData:IPixiesVsPiratesGameData):boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseExtraSymbolsOnTop(rawData:IPixiesVsPiratesGameData):string[][] {
        return ServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }

    public parsePlayerFSSelection(rawData:IPixiesVsPiratesServerData):number {
        return rawData.playerFSSelection;
    }

    public parseFreespinRound(rawData:IPixiesVsPiratesServerData):number {
        return rawData.freespinRound;
    }

    public parsePixieFSCount(rawData:IPixiesVsPiratesServerData):number {
        return rawData.pixieFSCount;
    }

    public parsePirateFSCount(rawData:IPixiesVsPiratesServerData):number {
        return rawData.pirateFSCount;
    }

    public parseMysterySymbolOnReel(rawData:IPixiesVsPiratesGameData):boolean[] {
        return rawData.mysterySymbolOnReel.concat();
    }

    public parseMysterySymbolPositions(rawData:IPixiesVsPiratesGameData):number[] {
        return rawData.mysterySymbolPositions.concat();
    }

    public parseMysterySymbolRevealed(rawData:IPixiesVsPiratesGameData):string {
        return rawData.mysterySymbolRevealed;
    }

    public parseMysterySymbolSize(rawData:IPixiesVsPiratesGameData):number[] {
        return rawData.mysterySymbolSize.concat();
    }

    public parseGameAreaSizeEnteringFreespin(rawData:IPixiesVsPiratesGameData):number[] {
        return rawData.gameAreaSizeEnteringFreespin.concat();
    }

    public parseRawReelsEnteringFreespin(rawData:IGameData):string[][] {
        return rawData.reelsEnteringFreespin!;
    }

    public parseReelsEnteringFreespin(rawData:IGameData):string[][] | undefined {
        return undefined;
    }

    public parseWildMultipliers(rawData:IPixiesVsPiratesServerData):number[] {
        if(rawData.wildMultipliers) {
            return rawData.wildMultipliers.concat();
        }
        return [0, 0, 0, 0, 0, 0];
    }

    public parseWildMultipliersEnteringFreespin(rawData:IPixiesVsPiratesGameData):number[] {
        return rawData.wildMultipliersEnteringFreespin.concat();
    }

    public parseNumberOfSpinsPerFSRound(rawData:IPixiesVsPiratesServerData):number {
        return rawData.numberOfSpinsPerFSRound;
    }

    public parsePixieCollectPositions(rawData:IPixiesVsPiratesGameData):boolean[][] {
        return rawData.pixieCollectPositions.concat();
    }

    public parsePirateCollectPositions(rawData:IPixiesVsPiratesGameData):boolean[][] {
        return rawData.pirateCollectPositions.concat();
    }

    public parseXWaysSymbolMayGiveWin(rawData:IPixiesVsPiratesGameData):boolean {
        return rawData.xWaysSymbolMayGiveWin;
    }
}